// 약관 코드

// AI피드그룹코드
export const AI_FEED_GRP_CD_MDCT = '041001';

export const SCARPING_TYP = {
  HIRA_MEDICATION: 'HIRA_MEDICATION', // 심평원 > 내가먹는약
  HIRA_MEDICALTREATMENT: 'HIRA_MEDICALTREATMENT', // 심평원 > 내 진료정보열람
  MECHUP: 'MECHUP', // 건강보험공단 > 건강검진
  HELT: 'HELT', // 건강보험공단 > 건강예측
  INFTSMECHUP: 'INFTSMECHUP', // 건강보험공단 > 영유아건강검진
};

export const CARE_TYP = {
  // 돌봄대상자관계코드
  CARE_TYP_CD_SELF: '046001', // 본인
  CARE_TYP_CD_CHILDREN: '046002', // 자녀
  CARE_TYP_CD_PARENT: '046003', // 부모님
  CARE_TYP_CD_SPOUSE: '046004', // 배우자
  CARE_TYP_CD_AGENT: '046005', // 대리인
};

export const AUTH_TYPE = {
  KAKAO: '003003',
  PASS: '003004',
  NAVER: '003007',
};
